/* eslint-disable jsx-a11y/anchor-is-valid */
import React from 'react';
import './CallToAction.css';
import '../../components/Pages/style.css'
import { Link } from 'react-router-dom';
const CallToAction = () => {
    return (
        <div className="pb-20 md:pb-0 mb-5 lg:mb-0">
     <div class="animated-button1">
        <span></span>
        <span></span>
        <span></span>
        <span></span>
        <h2 className="call-title">Would You Like To Discuss With Me For Your Project?</h2>
        <div className="flex items-center justify-center">
        <div className="portfolio">
        <a target="_blank" href="https://calendly.com/swe-hamedhasan/interview-schedule" rel=" noreferrer">
      <button className="portfolio__button bg-primary" style={{'--content': 'Hover me!'}}>
        <div className="portfolio__left text-neutral"></div>
        FREE SCHEDULE CALL
        <div className="portfolio__right"></div>
      </button>
        </a>

    </div>
    <div className="portfolio">
      <button className="portfolio__button text-neutral bg-primary" style={{'--content': 'Hover me!'}}>
        <div className="portfolio__left"></div>
        <Link to="/contact" >CONTACT ME</Link>
        <div className="portfolio__right"></div>
      </button>

    </div>
        </div>
        </div>
        </div>
    );
};

export default CallToAction;